/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import { SmtpSettingState } from '../state/SmtpSettingState'
import { SmtpSettingActionTypes } from '../../action/auto_action/SmtpSettingActions'

class SmtpSettingsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case SmtpSettingActionTypes.fetchAll:
        return List(payload.smtp_settings.map(model => new SmtpSettingState().merge(model)))
      case SmtpSettingActionTypes.onEdit:
        return state
      case SmtpSettingActionTypes.onCreate:
        return state.clear()
      default:
        return state
    }
  }
}

export default new SmtpSettingsStore()
